import React, { useEffect } from 'react';
import { loadRecurly, RecurlyWrapper, CheckoutForm } from '@fff-web/fff-payments';
import { EPayContext } from '@fff-web/fff-payments/dist/interfaces';
import { ProspectFooter } from '@fff-web/fff-global-footer';
import Toast, { showWarningToast } from '@fff-web/fff-ui-shared/Toast';

import { useAppContext } from '../../utils/ContextProviders/AppContext';
import { useSharedContext } from '../../pages/GTBCustomize/ContextProviders/SharedContext';
import { useGTBCheckoutContext } from '../../pages/GTBCustomize/ContextProviders/GTBContext';
import { usePublicShopContext } from '../../pages/GTBCustomize/ContextProviders/PublicShopContext';
import YourChoices from '../YourChoices';

import {
  warningToastContent,
  warningToastTitle,
} from '../../utils/constants/checkout';
import { checkShippingRestrictions } from '../Checkout/utils/checkoutUtils';
import EXPERIENCE_FLOW from '../../utils/constants/experienceFlow';
import styles from './CheckoutV2.module.scss';
import PromoGiftCard from '../../pages/GTBCustomize/components/OrderSummary/PromoGiftCard';

type Flags = {
  enableApplePaySocialEcomm: boolean;
};

type Props = {
  title: string;
  flags?: Flags;
};

const getProductData = (isPublicShop: boolean) => {
  if (isPublicShop) {
    const {
      choices, sku, hasRefill, hasIntro, subtotal,
    } = usePublicShopContext();
    return {
      choices,
      sku,
      hasRefill,
      hasIntro,
      subtotal,
    };
  }
  return {
    choices: [],
    sku: '',
    hasRefill: false,
    hasIntro: false,
    subtotal: 0,
  };
};

const CheckoutV2 = ({ title, flags }: Props) => {
  const { recurlyLoaded } = useAppContext();
  const {
    experienceFlow,
    prospect: {
      address: { shipCountry },
    },
    countries,
    planCode,
  } = useSharedContext();
  const isPublicShop = experienceFlow === EXPERIENCE_FLOW.publicShop;
  const useContext = isPublicShop
    ? usePublicShopContext
    : useGTBCheckoutContext;
  const {
    sku, hasRefill, hasIntro, subtotal,
  } = getProductData(isPublicShop);
  const { cartId } = usePublicShopContext();
  const { choices } = useContext();

  useEffect(() => {
    loadRecurly();
  }, []);

  useEffect(() => {
    if (checkShippingRestrictions(choices, shipCountry)) {
      showWarningToast(warningToastTitle, warningToastContent);
    }
  }, [shipCountry]);

  return (
    <>
      <div className={styles.coBody}>
        {recurlyLoaded && (
          <RecurlyWrapper>
            <CheckoutForm
              flags={flags}
              orderSummary="publicShop"
              cartId={cartId}
              orderSummaryProps={{
                productData: {
                  choices,
                  sku,
                  hasRefill,
                  hasIntro,
                  subtotal: Number(subtotal),
                },
              }}
              countries={countries}
              selectedPlan={planCode}
              headerTitle={title}
              sku={sku}
              payContext={'intro'}
              PromoGiftCard={PromoGiftCard}
            >
              <YourChoices choices={choices} />
            </CheckoutForm>
          </RecurlyWrapper>
        )}
      </div>
      <ProspectFooter />
      <Toast />
    </>
  );
};

CheckoutV2.defaultProps = {
  flags: {
    enableApplePaySocialEcomm: false,
  },
};

export default CheckoutV2;
